import httpManager from "@/app/shared/utils/httpManager";

/**
 * Exportar un contacto a hubspot.
 *
 */
export async function updateContactHubspot(clientId) {
  return await httpManager.post(`/hubspot/clients/sync-hubspot/${clientId}/`);
}
